import {UyapRequest} from "@/plugins/uyap-plugin/uyap/UyapRequest";

export interface SorguBakiyesiTalep {
    dosyaId: string
}

export interface SorguBakiyesiCevap extends IDosyaKota {
}

interface IDosyaKota {
    hasBarokart: boolean,
    sorguBakiye: number,
    sorguBakiyeAltLimit: number,
    sorguKalanIslemSayisi: number,
    sorguToplamIslemSayisi: number,
    ucretsizSorguLimit: number,
}

interface IBarokartBakiye {
    type: string,
    value: string,
    log: string
}

export default class SorguBakiyesi extends UyapRequest<SorguBakiyesiTalep, SorguBakiyesiCevap> {
    getMethod(): "POST" | "GET" {
        return "POST";
    }

    getSpinnerMessage(){
        return "Sorgu bakiyesi sorgulanıyor...";
    }

    cache(): { active: boolean; ttl: number; key: string } {
        return {
            active: false,
            ttl: 0,
            key: "_"
        };
    }

    getUrl(): string {
        return this.ImzaClientAddr + "ws_sorgu_bakiyesi.ajx";
    }

    getMockResponse(): any {
        return {
            "sorguBakiye": 83,
            "hasBarokart": false,
            "sorguToplamIslemSayisi": 5,
            "sorguKalanIslemSayisi": 0,
            "ucretsizSorguLimit": 5,
            "sorguBakiyeAltLimit": 50
        };
    }

    async parse(data: any): Promise<SorguBakiyesiCevap> {
        return data;
    }
}